var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 370,
    height: 306,
    viewBox: "0 0 370 306",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119.724 176.105L133.546 165.396L133.158 213.536L119.327 224.245L119.724 176.105Z",
    fill: "#175F77"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8912 89.4015L60.7134 78.6924L133.546 165.396L119.724 176.105L46.8912 89.4015Z",
    fill: "#19657F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1212 46.6834L107.943 35.9658L60.7134 78.6925L46.8912 89.4016L94.1212 46.6834Z",
    fill: "#175F77"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M161.502 128.708L175.325 117.998L191.957 106.234L178.135 116.943L161.502 128.708Z",
    fill: "#19657F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M178.134 116.943L191.957 106.234L208.369 121.351L194.547 132.069L178.134 116.943Z",
    fill: "#196681"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M194.547 132.069L208.37 121.352L207.619 213.528L193.796 224.245L194.547 132.069Z",
    fill: "#175F77"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7634 11.5997L94.5856 0.890625L290.881 20.8393L277.059 31.5569L80.7634 11.5997Z",
    fill: "#1A6A85"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M356.169 120.533L370 109.815L173.882 295.291L160.06 306L356.169 120.533Z",
    fill: "#175F77"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M277.058 31.5572L290.881 20.8396L369.999 109.815L356.169 120.532L277.058 31.5572Z",
    fill: "#19657F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M277.059 31.5575L356.169 120.533L160.06 306L161.503 128.708L178.135 116.943L194.548 132.07L193.796 224.246L309.606 116.107L263.152 63.8622L94.1215 46.6837L46.8915 89.402L119.724 176.105L119.327 224.246L0.328125 84.3599L80.7634 11.6003L277.059 31.5575Z",
    fill: "#2DB7E7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/Logo2.e1579372f25300c3439722e600a4b12f.svg";
export { ForwardRef as ReactComponent };